/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import injectTapEventPlugin from 'react-tap-event-plugin';
import UrlHandler from './url.handler';

/* eslint-disable import/no-unresolved, import/default */

import mdiIconSet from '../svg/mdi.svg';
import tkIconSet from '../svg/tk-icon-set.svg';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function AppConfig($provide,
                                  $urlRouterProvider,
                                  $locationProvider,
                                  $mdIconProvider,
                                  $mdThemingProvider,
                                  $httpProvider,
                                  $translateProvider,
                                  storeProvider,
                                  locales) {

    injectTapEventPlugin();
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise(UrlHandler);
    storeProvider.setCaching(false);

    $translateProvider.useSanitizeValueStrategy('sce');
    $translateProvider.preferredLanguage('en_US');
    $translateProvider.useLocalStorage();
    $translateProvider.useMissingTranslationHandler('tkMissingTranslationHandler');
    $translateProvider.addInterpolation('$translateIntlMessageFormatInterpolation');

    for (var langKey in locales) {
        var translationTable = locales[langKey];
        $translateProvider.translations(langKey, translationTable);
    }

    $httpProvider.interceptors.push('globalInterceptor');

    $provide.decorator("$exceptionHandler", ['$delegate', '$injector', function ($delegate) {
        return function (exception, cause) {
            $delegate(exception, cause);
        };
    }]);

    $mdIconProvider.iconSet('mdi', mdiIconSet);
    $mdIconProvider.iconSet('tk', tkIconSet);

    configureTheme();

    function tektelicTheme() {
        var tkPrimaryPalette = $mdThemingProvider.extendPalette('teal', {
            '500': '#004d40',
            '900': '#009688'
        });

        var tkAccentPalette = $mdThemingProvider.extendPalette('red', {
            '500': '#b71c1c'
        });

        $mdThemingProvider.definePalette('tk-primary', tkPrimaryPalette);
        $mdThemingProvider.definePalette('tk-accent', tkAccentPalette);

        var tkDarkPrimaryPalette = $mdThemingProvider.extendPalette('tk-primary', {
            '500': '#9fa8da'
        });

        var tkDarkPrimaryBackgroundPalette = $mdThemingProvider.extendPalette('tk-primary', {
            '800': '#004d40'
        });

        $mdThemingProvider.definePalette('tk-dark-primary', tkDarkPrimaryPalette);
        $mdThemingProvider.definePalette('tk-dark-primary-background', tkDarkPrimaryBackgroundPalette);

        $mdThemingProvider.theme('default')
            .primaryPalette('tk-primary')
            .accentPalette('tk-accent');

        $mdThemingProvider.theme('tk-dark')
            .primaryPalette('tk-dark-primary')
            .accentPalette('tk-accent')
            .backgroundPalette('tk-dark-primary-background')
            .dark();
    }

    function configureTheme() {
        tektelicTheme();
        $mdThemingProvider.setDefaultTheme('default');
    }

}


// WEBPACK FOOTER //
// ./src/app/app.config.js